<template>
  <div id="Admin_Payment">
    <!-- 標題 -->
    <v-title>
      <font-awesome-icon icon="dollar-sign" />
      收費項目管理
    </v-title>
    <hr class="no-print">
    <!-- 內容主版 -->
    <div class="tab-content pb-4">
      <ul
        id="adminpayment"
        class="nav nav-tabs"
        role="tablist"
      >
        <li class="nav-item">
          <a
            id="apr"
            class="nav-link"
            :class="[isActive ? 'active' : '']"
            :href="'#/admin/payment/review'"
            @click="FeeorderList('true')"
            role="tab"
            aria-controls="areview"
            aria-selected="true"
          >
            收費項目管理
          </a>
        </li>
        <li class="nav-item">
          <a
            id="aps"
            class="nav-link"
            :class="[isActives ? 'active' : '']"
            :href="'#/admin/payment/setup'"
            @click="FeeorderList('false')"
            role="tab"
            aria-controls="asetup"
            aria-selected="false"
          >
            繳款項目建立
          </a>
        </li>
      </ul>
      <Review v-if="isActive" />
      <Setup v-if="isActives" />
    </div>
  </div>
</template>

<script>
import Review from './Review'
import Setup from './Setup'
export default {
  components: {
    Review,
    Setup
  },
  data () {
    return {
      isActive: true,
      isActives: false
    }
  },
  methods: {
    FeeorderList (data) { // 觸發切換頁籤
      const vm = this
      if (data === 'true') {
        vm.isActive = true
        vm.isActives = false
      } else {
        vm.isActive = false
        vm.isActives = true
      }
    }
  }
}
</script>
